import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { AnalyticsService } from 'src/app/global/services/analytics.service';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { Tools } from 'src/utilities/tools';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { ExtendedModule } from '@angular/flex-layout';
@Component({
	selector: 'app-language-chooser',
	templateUrl: './language-chooser.component.html',
	styleUrls: ['./language-chooser.component.scss'],
	standalone: true,
	imports: [
		MatButtonModule,
		MatMenuModule,
		FlexModule,
		TitleCasePipe,
		ExtendedModule,
		CommonModule,
	],
})
/** *Language Chooser Component */
export class LanguageChooserComponent implements OnInit {
	// Define language mappings
	languageMap: any = {
		nl: '/nl',
		en: '',
		es: '/es',
		de: '/de',
		fr: '/fr',
		bg: '/bg',
		hr: '/hr',
		cs: '/cs',
		da: '/da',
		fi: '/fi',
		el: '/el',
		hu: '/hu',
		it: '/it',
		pl: '/pl',
		pt: '/pt',
		ro: '/ro',
		sk: '/sk',
		sv: '/sv',
		uk: '/uk',
	};
	locale: string = 'en';
	languageIcon: string =
		'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
		'en' +
		'1/public';
	@Input() languageCode: string = '';
	constructor(
		public router: Router,
		public accountService: AccountService,
		public analyticsService: AnalyticsService
	) {}

	ngOnInit(): void {
		this.setLanguageInFooter();
		// Get Locale from Address Bar
		this.locale = this.getLocaleFromAddressBar();
		this.updateOrSetLocale(this.locale);
		this.analyticsService.setZarazLanguage();
		Tools.setUserlanguage(this.locale);
	}

	getLocaleFromAddressBar(): string {
		const path = window.location.pathname.split('/');
		const locale = path[1]; // Assuming the locale is the first part of the path

		// If no locale in path, it's root → English
		if (!locale) return 'en';
		return this.languageMap[locale] ? locale : 'en';
	}

	changeLanguage(language: string) {
		this.updateOrSetLocale(language);
		this.analyticsService.setZarazLanguage();
		Tools.setUserlanguage(language);

		// Redirect based on language
		// Set or clear the locale cookie based on language selection
		const detectedLanguage =
			Object.keys(this.languageMap).find((lang) => language.includes(lang)) ||
			'en';

		if (detectedLanguage === 'en') {
			// ❌ Don't remove the cookie
			// ✅ Instead, store the explicit preference for 'en'
			document.cookie = `WD_locale_preference=en; path=/; max-age=${
				365 * 24 * 60 * 60
			}`;
		} else {
			document.cookie = `WD_locale_preference=${detectedLanguage}; path=/; max-age=${
				365 * 24 * 60 * 60
			}; SameSite=Lax;`;
		}

		// Redirect to selected language path
		window.location.href = this.languageMap[detectedLanguage] + this.router.url;

		//FOOTER
		this.setLanguageInFooter();
	}
	/** *set current route */
	setLanguageInFooter() {
		const path = window.location.pathname.split('/')[1];
		this.locale = this.languageMap[path] ? path : 'en';

		this.languageIcon =
			'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
			this.locale?.substring(0, 2).toLowerCase() +
			'1/public';
	}

	// Function to manage the WD_locale in localStorage based on the provided locale
	updateOrSetLocale(locale: string): void {
		try {
			// Update or set the locale in localStorage
			localStorage.setItem('WD_locale', locale);
		} catch (error: any) {
			console.error(
				'Error while managing the WD_locale in localStorage:',
				error?.message
			);
		}
	}

	// Helper function to get the locale value from localStorage
	getLocale(key: string): string | null {
		try {
			return localStorage.getItem(key) || null;
		} catch (error: any) {
			console.error('Error while accessing localStorage:', error?.message);
			return null;
		}
	}
}
